import { setDynamicWidth } from "./set-dynamic-width";
var DollarFormatter = function (decimals) {
    if (decimals === void 0) { decimals = 2; }
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};
var ɵ0 = DollarFormatter;
function formatMillions(value, minDecimals, maxDecimals) {
    if (minDecimals === void 0) { minDecimals = 0; }
    if (maxDecimals === void 0) { maxDecimals = 1; }
    return (new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: maxDecimals
    }).format(Math.round((value / 1000000) * 10) / 10) + "m");
}
var DefaultPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 0
});
var PercentFormatter = function (decimals) {
    if (decimals === void 0) { decimals = 2; }
    return new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};
var ɵ1 = PercentFormatter;
function formatPercent(value, forceFractionDigits, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 2; }
    var percent = value / 100;
    if (forceFractionDigits) {
        return PercentFormatter(fractionDigits).format(percent);
    }
    return DefaultPercentFormatter.format(percent);
}
function formatDollars(value, includeDollarSign, fractionDigits, shouldFormatMillons) {
    if (includeDollarSign === void 0) { includeDollarSign = true; }
    if (fractionDigits === void 0) { fractionDigits = 2; }
    if (shouldFormatMillons === void 0) { shouldFormatMillons = false; }
    var formattedValue = DollarFormatter(fractionDigits).format(value);
    if (value >= 1000000 && shouldFormatMillons) {
        formattedValue = formatMillions(value);
    }
    if (!includeDollarSign) {
        formattedValue = formattedValue.substring(1);
    }
    //handle N.N case to add 0 on the end
    if (formattedValue.length > 2 && formattedValue.indexOf(".") === formattedValue.length - 2) {
        return formattedValue + "0";
    }
    return formattedValue;
}
function formatPhone(value) {
    //normalize string and remove all unnecessary characters
    var phone = value.replace(/[^\w]/g, "");
    //check if number length equals to 10
    if (phone.length == 10) {
        //reformat and return phone number
        return phone.replace(/(\w{3})(\w{3})(\w{4})/, "1-$1-$2-$3");
    }
    return null;
}
function roundToPlanIncVal(value, planIncVal, maxDecimals) {
    if (planIncVal === 1) {
        return value;
    }
    var factor = planIncVal === 0.5 ? 2 : planIncVal === 0.1 ? 1 : 4;
    var a = value * factor;
    var b = Math.round(a);
    var c = b / factor;
    var d = c.toFixed(maxDecimals);
    var e = Number(d);
    return e;
}
export function sanitize(str) {
    return str
        .replace("$", "")
        .replace("%", "")
        .replace(/,+/g, "");
}
var mask = function (element) {
    var el = element;
    // removes "$ % ," from string
    // add an appropriate prefix or suffix or none
    function getSymbol(type, str) {
        return type === "formatDollars" ? "$" + str : type === "formatPercent" ? str + "%" : str;
    }
    var obj = {
        allowOnlyNumbers: function (allowDecimals) {
            if (allowDecimals === void 0) { allowDecimals = false; }
            var regex = allowDecimals
                ? /[a-zA-Z~`!@#$%^&*()_={}[\]:;,<>+\/?\\'"\|-]/g
                : /[a-zA-Z~`!@#$%^&*()_={}[\]:;,.<>+\/?\\'"\|-]/g;
            var val = "" + el.value.replace(regex, "") || "";
            // remove any second decimal that is entered by user
            if (allowDecimals && val.split(".").length > 2) {
                val = val.replace(/\.+$/, el.value);
            }
            el.value = val;
            return this;
        },
        setMask: function (type, options) {
            if (type === void 0) { type = "formatDollars"; }
            var val = parseFloat(sanitize(el.value)).toFixed(2);
            if (type === "formatDollars" && !isNaN(Number(sanitize(val)))) {
                var result = formatDollars(Number(val), options.symbol, options.digits);
                el.value = result;
            }
            else if (type === "formatPercent" && !isNaN(Number(sanitize(val)))) {
                var result = formatPercent(Number(val), options.forceFractionDigits, options.digits);
                el.value = !options.symbol ? result.replace("%", "") : result;
            }
            else {
                // forces a "0" in the scenario were decimals are allowed
                // and the user enters only decimals, e.g. "....."
                var result = Number(parseFloat(sanitize(el.value)));
                el.value = "" + (isNaN(result) ? "" + getSymbol(type.toString(), "0") : result);
            }
            return this;
        },
        dynamicWidth: function () {
            setDynamicWidth(el);
            return this;
        }
    };
    return obj;
};
var ɵ2 = mask;
export { formatDollars, formatPercent, formatPhone, mask, roundToPlanIncVal };
export { ɵ0, ɵ1, ɵ2 };
//# sourceMappingURL=value-formatter.js.map